module.exports = __webpack_public_path__ + "static/2_2x-4ec4be9d09ce9e869f40169b1f5faf27.png";